@if (chapter) {
    <button (click)="turnToPage(chapter)"
       class="main-chapter single-chapter-container">
        <app-main-chapter-heading [chapter]="chapter"></app-main-chapter-heading>
    </button>
}

@if (chapter.subChapters.length > 0) {
    <ul class="sub-chapters">
        @for (subChapter of chapter.subChapters; track subChapter) {
            <li class="sub-chapter">
                <button (click)="turnToPage(subChapter)"
                   class="single-chapter-container">
                  <span class="float-end">
                    <span class="chapter-number">{{ getRealPageNumber(subChapter) }}</span>
                  </span>
                    @if (showChapterNames && subchapterHierarchyMap.get(subChapter.id)) {
                        <span class="chapter-label">{{ subchapterHierarchyMap.get(subChapter.id).join('.') }}.</span>
                    }
                    @if (!showChapterNames) {
                        <span class="chapter-label">{{ subChapter.orderName }}</span>
                    }
                    <span class="chapter-title">{{ subChapter.title }}</span>
                </button>
            </li>
        }
    </ul>
}

